// =================================================================
// PastedContentChip.js - Affichage compact du contenu collé
// Session 34 — Chip expand/collapse pour contenus longs
// =================================================================

import React, { useState } from 'react';
import { FileText, Code, Database, Image, ChevronDown, ChevronUp, Globe } from 'lucide-react';

const TYPE_ICONS = {
  javascript: Code, html: Code, css: Code, code: Code,
  markdown: FileText, text: FileText, csv: Database,
  image: Image, url: Globe,
};

const PastedContentChip = ({ pasteItems, fullContent }) => {
  const [expandedIdx, setExpandedIdx] = useState(null);

  if (!pasteItems || pasteItems.length === 0) return null;

  return (
    <div style={{ marginBottom: '8px' }}>
      {pasteItems.map((item, idx) => {
        const Icon = TYPE_ICONS[item.type] || FileText;
        const isExpanded = expandedIdx === idx;

        // Extraire le contenu du fichier depuis fullContent si possible
        const contentPreview = item.content_preview || '';
        const sizeLabel = item.content_length
          ? item.content_length > 1000
            ? `${(item.content_length / 1000).toFixed(1)}k chars`
            : `${item.content_length} chars`
          : item.size || '';

        return (
          <div key={idx} style={{ marginBottom: '4px' }}>
            <button
              onClick={() => setExpandedIdx(isExpanded ? null : idx)}
              style={{
                display: 'inline-flex', alignItems: 'center', gap: '6px',
                padding: '5px 10px', borderRadius: '8px',
                background: 'rgba(29,78,216,0.08)',
                border: '1px solid rgba(29,78,216,0.2)',
                cursor: 'pointer', color: '#3b82f6',
                fontSize: '11px', fontWeight: 500,
                transition: 'all 0.15s',
                maxWidth: '100%',
              }}
              onMouseEnter={e => e.currentTarget.style.background = 'rgba(29,78,216,0.15)'}
              onMouseLeave={e => e.currentTarget.style.background = 'rgba(29,78,216,0.08)'}
            >
              <Icon size={12} style={{ flexShrink: 0 }} />
              <span style={{
                overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap',
                maxWidth: '200px',
              }}>
                {item.filename || 'Contenu collé'}
              </span>
              {sizeLabel && (
                <span style={{ color: 'var(--text-secondary)', fontSize: '10px', flexShrink: 0 }}>
                  {sizeLabel}
                </span>
              )}
              {isExpanded ? <ChevronUp size={10} /> : <ChevronDown size={10} />}
            </button>

            {isExpanded && (
              <div style={{
                marginTop: '4px', padding: '8px 12px', borderRadius: '8px',
                background: 'var(--input-bg)', border: '1px solid var(--card-border)',
                maxHeight: '200px', overflowY: 'auto',
                fontSize: '11px', lineHeight: '1.5', color: 'var(--text-secondary)',
                whiteSpace: 'pre-wrap', wordBreak: 'break-word', fontFamily: 'monospace',
              }}>
                {contentPreview || '(aperçu non disponible)'}
              </div>
            )}
          </div>
        );
      })}
    </div>
  );
};

export default PastedContentChip;
